export const data = 
{    
  columns: [
    {
      label: 'Position',
      field: 'position',
      width: 200,
    },
    {
      label: 'Company',
      field: 'company',
      width: 200,
      attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Company',
    },
    },
    {
      label: 'Industry',
      field: 'industry',
      width: 200,
    },
    {
      label: 'Location',
      field: 'location',
      width: 200,
    },
    {
      label: 'Salary',
      field: 'salary',
      sort: 'asc',
      width: 100,
    },
    {
      label: 'Length',
      field: 'length',
      width: 100,
    },
    {
      label: 'Skills',
      field: 'skills',
      width: 300,
    },
    {
      label: 'Office',
      field: 'remote',
      width: 100,
    },
    {
      label: 'Status',
      field: 'status',
      width: 100,
    },
    ],
    rows: [
      {
        position: 'Software Engineer Intern',
        company: 'Google',
        industry: 'Technology',
        location: 'Toronto, ON',
        salary: '$67,000',
        length: '12 month',
        skills: 'JavaScript, NodeJS, Python, Flask',
        remote: 'Remote',
        status: 'Applied', 
      },
      {
        position: 'Technical Consulting Intern',
        company: 'TD Bank',
        industry: 'Consulting',
        location: 'Toronto, ON',
        salary: '$60,000',
        length: '12 month',
        skills: 'JavaScript, Python, Power Point',
        remote: 'Remote',
        status: 'Applied', 
      }, 
      {
        position: 'Software Engineer Intern',
        company: 'TD Bank',
        industry: 'Technology',
        location: 'Ottawa, ON',
        salary: '$66,000',
        length: '12 month',
        skills: 'Python, Flask, Docker',
        remote: 'In-Office',
        status: 'Interviewed', 
      }, 
      {
        position: 'Data Science Intern',
        company: 'RBC',
        industry: 'Finance',
        location: 'Vancouver, BC',
        salary: '$59,000',
        length: '8 month',
        skills: 'Python, R, NumPy',
        remote: 'In-Office',
        status: 'Declined', 
      }, 
      {
        position: 'Software Engineer Intern',
        company: 'Shopify',
        industry: 'E-Commerce',
        location: 'Ottawa, ON',
        salary: '$68,000',
        length: '8 month',
        skills: 'Docker, Git, Kubernetes',
        remote: 'Remote',
        status: 'Offered', 
      }, 
      {
        position: 'Data Science Intern',
        company: 'Shopify',
        industry: 'E-Commerce',
        location: 'Ottawa, ON',
        salary: '$60,000',
        length: '12 month',
        skills: 'Python, R, NumPy',
        remote: 'Remote',
        status: 'Declined', 
      }, 
      {
        position: 'Financial Analyst Intern',
        company: 'RBC',
        industry: 'Finance',
        location: 'Toronto, ON',
        salary: '$55,000',
        length: '12 month',
        skills: 'Power Point, Excel, Python',
        remote: 'In-Office',
        status: 'Interviewed', 
      }, 
      {
        position: 'Sofware Engineer Intern',
        company: 'RBC',
        industry: 'Finance',
        location: 'Toronto, ON',
        salary: '$65,000',
        length: '12 month',
        skills: 'Python, MongoDB, JavaScript',
        remote: 'In-Office',
        status: 'Offered',
      }, 
      {
        position: 'Research Intern',
        company: 'Queens University',
        industry: 'Biology',
        location: 'Kingston, ON',
        salary: '$50,000',
        length: '12 month',
        skills: 'Power Point, Excel',
        remote: 'In-Office',
        status: 'Not Applied',
      }, 
      {
        position: 'Product Manager Intern',
        company: 'Microsoft',
        industry: 'Technology',
        location: 'Vancouver, ON',
        salary: '$63,000',
        length: '8 month',
        skills: 'Docker, Git, Kubernetes',
        remote: 'Remote',
        status: 'Not Applied',
      },
      {
        position: 'Product Manager Intern',
        company: 'Google',
        industry: 'Technology',
        location: 'Toronto, ON',
        salary: '$70,000',
        length: '8 month',
        skills: 'Jira, Excel, Flask, JavaScript',
        remote: 'Remote',
        status: 'Not Applied',
      },  
      {
        position: 'Product Manager Intern',
        company: 'ecobee',
        industry: 'IoT',
        location: 'Toronto, ON',
        salary: '$69,000',
        length: '12 month',
        skills: 'Jira, Excel, Flask, JavaScript',
        remote: 'Remote',
        status: 'Not Applied',
      },  
      {
        position: 'Software Engineer Intern',
        company: 'ecobee',
        industry: 'IoT',
        location: 'Toronto, ON',
        salary: '$71,000',
        length: '12 month',
        skills: 'Python, Excel, Flask, JavaScript',
        remote: 'Toronto, ON',
        status: 'Not Applied',
      },
      {
        position: 'Data Analyst Intern',
        company: 'ecobee',
        industry: 'IoT',
        location: 'Toronto, ON',
        salary: '$65,000',
        length: '12 month',
        skills: 'Python, Excel, Flask, JavaScript',
        remote: 'Toronto, ON',
        status: 'Offered',
      },
    ],
  }
